import { useEffect, useState, useContext, memo, useMemo} from 'react'
import {  Link, useLocation, useParams, useNavigate } from "react-router-dom";
import { useQuery } from "react-query";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";

import { VscArrowLeft, VscArrowRight } from "react-icons/vsc";

import { AppContext } from "../../Context";
import { Loader, DateToText, Get, priceFormat, numberFormat, totalPrice } from "../inc/Fetch";
import { Img, AddToCart } from "../components/Elements";
import Product from "../components/product/Product";
import Options from "../components/product/Options";
import NumberCart from "../components/product/Number";
import ErrorPage from "./ErrorPage";

import { FaSquare } from "react-icons/fa6";
import { IoCloseSharp } from "react-icons/io5";



import './css/Product.css'

export function MainImgVid({src, setfullScreenImg}) {
        
    if (src?.indexOf("https://") > -1 ) {
        //&autoplay=1&mute=1
        return (
            <iframe className='youtubeVideo' src={`${src}`} frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen="allowfullscreen" referrerpolicy="strict-origin-when-cross-origin"></iframe>
        );
        
    } else {
        return (
            <Img onClick={() => setfullScreenImg(true)} className='mainImg' src={`img/600/${src}`} /> 
        );
    }
}

export default function Home() {

    const { t } = useTranslation();
    const params = useParams();
    const navigate = useNavigate();

    let i = 0;
	const {siteData, cartData, user} = useContext(AppContext); 
	const [siteInfo, setsiteInfo] = siteData;
	const [cart, setcart] = cartData;
    const [userinfo, setuserinfo] = user;

    const [mostProducts, setmostProducts] = useState([]);
    const [selectedImg, setselectedImg] = useState(0);
    const [price, setprice] = useState(0);
    const [productOptions, setproductOptions] = useState([]);
    const [fullScreenImg, setfullScreenImg] = useState(false);
    
    async function loadData() {
        let res = await Get('product?_id=' + params?.id);

        // let ifr = res?.product?.full;
        // var parser = new DOMParser();

        // var parsedIframe = parser.parseFromString(ifr, "text/html");
        // let iFrame = parsedIframe.getElementsByTagName("iframe");

        // if (!res.product.img?.length) {
        //     res.product.img = [];
        // }

        // let ims = [];
        // for(let i = 0;i < iFrame.length; i++) {
        //     ims.push(iFrame[i].src);
        //     iFrame[i].parentNode.removeChild(iFrame[i])
        // }

        // if (res.product.img?.length || ims?.length) {
        //     res.product.img = [...ims, ...res.product.img]
        // }

        return res;
    }

    function youtube_parser(url){
        var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
        var match = url.match(regExp);
        return (match&&match[7].length==11)? match[7] : false;
    }

    
    const { data, error, isLoading } = useQuery(params?.id, loadData); 
    
    function addOptions(data) {

        if (data?.val) {
            setproductOptions(p => [...p?.filter(r => r?._id != data?._id), data]);
        } else {
            setproductOptions(p => [...p?.filter(r => r?._id != data?._id)]);
        }
        
    }

    let numOf = productOptions?.filter(p => p?._id == "qnt");
    
    function nextBack(type) {

        if (type == "next") {

            if (selectedImg >= data?.product?.img?.length -1) {
                setselectedImg(data?.product?.img?.length - 1);
            } else {
                setselectedImg(p => p + 1);
            }
        } else {
            
            if (selectedImg <= 0) {
                setselectedImg(0);
            } else {
                setselectedImg(p => p - 1);
            }
        }

        
    }
    
    const arePropsEqual = (prevProps, nextProps) => {  
        
        return false; 
    };


    useEffect(() => {
        window.scrollTo(0, 0);
    }, [params?.id]);

    useEffect(() => {
        setprice(data?.product?.price?.$numberDecimal);
    }, [data?.product?._id]);


    useEffect(() => {

        function r(e){ 
            let cls = e?.target?.className;
            console.log(cls);
            
            if (cls == "productScroll" || cls == "porudctPopup") {
                navigate(-1);
            }
            
        }

        document.addEventListener("click", r);

        return () => {
            document.removeEventListener("click", r);
        }
    }, []);

    useEffect(() => {
        let total = 0;
        let qntTotal = 1;
        let opTotal = 0;
        productOptions?.map((v) => {
            if (v?._id == "qnt") {
                qntTotal = v?.val;
            } else {
                
                if (v?.type == 'count') {
                    opTotal += v?.price * v?.val;
                } else {
                    opTotal += v?.price;
                }
            }
        });
        
        total = (Number(data?.product?.price?.$numberDecimal) + opTotal) * qntTotal;
        setprice(total);
        
    }, [productOptions]);
    

    if (isLoading) {
        return <Loader />;
    }

    if (!data?.product?._id) {
        return <ErrorPage />
    }

    
    
	return (
		<>
            <div className='porudctPopup'>
                <div className='productScroll'>
                    <div className='mainWidth productPageBox'>
                        <a className='close' onClick={() => navigate(-1)}><IoCloseSharp /></a>
                    
                        <div className={`productImgsBox ${fullScreenImg ? "fullScreen" : ""}`}>
                            {fullScreenImg && <a onClick={() => setfullScreenImg(false)} className='closeFullSreen'><IoCloseSharp /></a>}
                            <div className='mainImgBox'>

                                <a onClick={() => nextBack("back")} className='nextBackImg prev'><VscArrowRight /></a>
                                <a onClick={() => nextBack("next")} className='nextBackImg next'><VscArrowLeft /></a>

                                <MainImgVid src={data?.product?.img[selectedImg]} setfullScreenImg={setfullScreenImg} />
                            </div>
        
                            <div className='thumbs'>
                                {data?.product?.img?.map((v, k) => {
                                    let vid = youtube_parser(v);
                                    
                                    return (
                                        <a key={k} onClick={() => setselectedImg(k)}><Img className={k == selectedImg ? 'checked' : 'none'} src={vid ? `https://i.ytimg.com/vi/${vid}/hqdefault.jpg` : `img/500x500/${v}`} /></a>
                                    );
                                })}
        
                            </div> 
                        </div>
        
        
                        <div className='productInfoBox'>
                            <h1>{data?.product?.title}</h1>
                            <nav className='cats'>
                                {/* {data?.product?.cats?.map((v, k) => {
                                    return (
                                        <Link to={`/cat/${v?.val}`} key={k}>{v?.name} | </Link>
                                    );
                                })} */}
        
                                <a><FaSquare />{t("added")}: <DateToText time={data?.product?.date} /></a>
                               
                            </nav>
        
                            {siteInfo?.settings?.show_prices?.val == 1 || (siteInfo?.settings?.show_prices?.val == 0 && userinfo?._id) ? <dl>
                                {userinfo?.settings?.discount ?
                                    <>
                                        <dd >{priceFormat(price - price * (userinfo?.settings?.discount / 100) )}</dd>
                                        <dt>{global?.currency}</dt>
                                        <dd style={{textDecoration:"line-through", color:"#999", fontSize:12, marginBottom:6}}>{priceFormat(price)} {global?.currency}</dd>
                                    </>
                                :
                                    <>
                                        <dd >{priceFormat(price)}</dd>
                                        <dt>{global?.currency}</dt>
                                    </>
                                }

                            </dl>: false}
        
                            {data?.product?.options?.length ? <div className='productOptionsBox'>
                                <strong>{t("extra_options")}</strong>
                                {data?.product?.options?.map((v, k) => {
                                    return (
                                        <Options 
                                            key={k} 
                                            onChange={(v) => addOptions(v)}
                                            data={v} 
                                        />
                                    );
                                })}
                            </div>:false }
                                
                            <div className='moreProdInfo'>
                                <table>
                                    <tr>
                                        <td>{t("qnt_max")}</td>
                                        <td>{data?.product?.qnt}</td>
                                    </tr>
                                    {data?.product?.pid && <tr>
                                        <td>{t("product_id")}</td>
                                        <td>{data?.product?.pid}</td>
                                    </tr>}

                                    {data?.product?.barcode && <tr>
                                        <td>{t("barcode")}</td>
                                        <td>{data?.product?.barcode}</td>
                                    </tr>}

                                    <tr>
                                        <td>{t("categories")}</td>
                                        <td>
                                            <div style={{display:"flex", gap:5, alignContent:"center", flexWrap:"wrap"}}>
                                                {data?.product?.cats?.map((v, k) => {
                                                    return (
                                                        <span key={k} className='tag'>{v?.name}</span>
                                                    );
                                                })}
                                            </div>
                                        </td>
                                    </tr>

                                    {/* <tr>
                                        <td>{t("product_type")}</td>
                                        <td>{data?.product?.status?.name}</td>
                                    </tr> */}
                                </table>
                            </div>
                            
                                
        
                            <div className='submitBox'>
                                {/* <NumberCart onChange={(v) => addOptions(v)} qnt={data?.product?.qnt} value={numOf?.length ? numOf[0]?.val : 1}/> */}
                                <AddToCart data={data?.product} showNum={true} options={productOptions} />
                            </div>
                        </div>

                        
            
                    </div>

                    {data?.product?.full ? <div className='fullTextBox'>
                        <strong className='title'>{t("description")}</strong>

                        <div dangerouslySetInnerHTML={{__html:data?.product?.full }}>
                        </div>

                    </div>: false}

                    {siteInfo?.settings?.related?.val && data?.related?.length ? <div className='mainWidth homeTopProducts'>
        
                        <div className='titleBox'>
                            <h4>{t("similar_products")}</h4>
                            <h5>{t("similar_products_sub")}<hr /></h5>
                        </div>
        
                        <div className='productsBox list4'>
                            {data?.related?.map((v, k) => {
                                return (
                                    <Product data={v} key={k} /> 
                                );
                            })}
        
                        </div>
            
                    </div>: false }
                </div>
            </div>
		</>
	)
}
